import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { SelectUser } from './SelectUser';

export default react2angular(SelectUser, [
  'businessId',
  'permissionSecureCodes',
  'selectedUserId',
  'disabled',
  'onUserSelect',
  'popupClassName',
  'inputId',
  'containerClass',
  'exclude',
  'include',
  'excludeInvitedUsers',
  'showEmail',
  'noEmpty',
  'onDataLoadError',
  'loadUser'
]);
